// Module
var code = "<versions\n  variant-id=\"vm.variant.id\"\n  article-node-group=\"vm.nodeGroup\"\n></versions>\n";
// Exports
module.exports = code;